(function () {
  'use strict';

  angular
    .module('performanceDetailReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('performanceDetailReport', {
        url: '/performance-detail-report',
        views : {
        	'performanceDetailReportView' : {
        		templateUrl: 'performance-detail-report/views/performance-detail-report.tpl.html',
                controller: 'PerformanceDetailReportCtrl',
                controllerAs: 'performanceDetailReport'
        	}
        }
      });
  }
}());
